module.exports = __webpack_public_path__ + "assets/apple-icon-152x152.84dcf831.png";